import React, { useEffect, useRef } from 'react'

const CameraPreview = () => {
  const videoRef = useRef(null)
  const streamRef = useRef(null) // keep a reference to stop it later

  useEffect(() => {
    const getCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        })
        streamRef.current = stream
        if (videoRef.current) {
          videoRef.current.srcObject = stream
        }
      } catch (error) {
        console.error('Error accessing camera:', error)
      }
    }

    getCamera()

    return () => {
      // Cleanup: stop all tracks when component unmounts
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop())
      }
    }
  }, [])

  return (
    <div style={styles.container}>
      <video ref={videoRef} autoPlay muted style={styles.video} />
    </div>
  )
}

const styles = {
  container: {
    position: 'fixed',
    top: '1rem',
    right: '1rem',
    width: '350px',
    height: '262.5px',
    backgroundColor: '#000',
    borderRadius: '12px',
    overflow: 'hidden',
    zIndex: 1000,
    boxShadow: '0 0 10px rgba(0,0,0,0.3)',
  },
  video: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}

export default CameraPreview
